"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _CartProduct = require("./CartProduct");

var _CartProduct2 = _interopRequireDefault(_CartProduct);

var _HeaderContext = require("../HeaderContext");

var _HeaderContext2 = _interopRequireDefault(_HeaderContext);

var _tooltip = require("../Tooltip/tooltip");

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CartSubMenu = function CartSubMenu(props) {
  var children = props.children,
      callbacks = props.callbacks,
      campaignId = props.campaignId,
      cartText = props.cartText,
      products = props.products,
      onMouseLeave = props.onMouseLeave,
      isMobile = props.isMobile,
      right = props.right,
      total = props.total,
      appliedAddonCredit = props.appliedAddonCredit,
      appliedPurchaseCredit = props.appliedPurchaseCredit,
      remainingCredit = props.remainingCredit,
      subtotal = props.subtotal,
      fees = props.fees,
      expandProductDetails = props.expandProductDetails,
      closeMenu = props.closeMenu;
  var containerStyles = (0, _classnames2.default)({
    "pos-a": true,
    "z-1000": true,
    "fff-header-submenu-containter": true,
    mobile: isMobile,
    "cart-submenu": true,
    right: right
  });
  var subMenuStyles = (0, _classnames2.default)({
    "pos-r": true,
    "fff-header-submenu": true,
    right: right
  });

  var displayShippingFee = function displayShippingFee(fees) {
    if (!fees) {
      return "";
    }

    if (parseFloat(fees.shipping) === 0.0) {
      return "FREE";
    }

    return "$" + fees.shipping;
  };

  var formatCreditApplied = function formatCreditApplied(credit) {
    if (credit == null) {
      return "";
    }

    var parsedCredit = parseFloat(credit);

    if (parsedCredit == 0.00) {
      return "$0.00";
    }

    if (parsedCredit > 0) {
      return "-$" + credit;
    }
  };

  return _react2.default.createElement("div", {
    onMouseLeave: onMouseLeave,
    className: containerStyles
  }, _react2.default.createElement("div", {
    className: subMenuStyles
  }, _react2.default.createElement("i", {
    className: "material-icons pos-a"
  }, "arrow_drop_up"), children && children.map(function (child) {
    if (child.placementIndex < 1) {
      return _react2.default.createElement(_react2.default.Fragment, {
        key: child.key
      }, child.component);
    }
  }), remainingCredit != null && _react2.default.createElement("div", {
    className: "d-flex flex-jsb fs-12 c-white credit-remaining"
  }, _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, "Credit Remaining"), _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, "$" + remainingCredit)), _react2.default.createElement("ul", {
    className: "pad-0 mar-0 border-bottom cart-product-list"
  }, !!products && products.map(function (item) {
    return _react2.default.createElement("div", {
      key: item.id
    }, item.variants && item.variants.map(function (variant) {
      return _react2.default.createElement("li", {
        key: variant.id
      }, _react2.default.createElement(_CartProduct2.default, {
        id: item.id,
        name: item.name,
        variant: variant,
        quantity: variant.quantity,
        color: variant.color,
        inventoryState: variant.inventoryState,
        imageUrl: variant.imageUrl,
        salePrice: item.salePrice,
        callbacks: callbacks,
        campaignId: campaignId,
        cartLimit: variant.cartLimit,
        cartAmount: variant.cartAmount,
        descriptor: variant.descriptor,
        expandProductDetails: expandProductDetails,
        shareUrl: item.shareUrl,
        legacyPostId: item.legacyPostId
      }));
    }));
  })), !products || !products.length && _react2.default.createElement("div", {
    className: "italic fs-12 ta-center pad-16"
  }, "Your cart is currently empty...", _react2.default.createElement("br", null), "treat yourself and start shopping :)"), _react2.default.createElement("div", {
    className: "mar-b-8"
  }, appliedAddonCredit != null && _react2.default.createElement("div", {
    className: "d-flex flex-jsb fs-12 credit-applied pad-12"
  }, _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, "Credit Applied"), _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, formatCreditApplied(appliedAddonCredit))), appliedPurchaseCredit != null && _react2.default.createElement("div", {
    className: "d-flex flex-jsb fs-12 pad-12"
  }, _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, "Purchase Credits Applied"), _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, formatCreditApplied(appliedPurchaseCredit))), fees && fees.tax != null && _react2.default.createElement("div", {
    className: "subtotal d-flex flex-jsb fs-12"
  }, _react2.default.createElement("p", {
    className: "mar-0 pad-0 fw-bold"
  }, "Subtotal"), _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, "$" + subtotal)), fees && fees.shipping != null && _react2.default.createElement("div", {
    className: "shipping fs-12"
  }, _react2.default.createElement("div", {
    className: "d-flex flex-jsb"
  }, _react2.default.createElement("p", {
    className: "mar-0 pad-0 fw-bold"
  }, "Shipping"), _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, displayShippingFee(fees))), !!fees.amountToFreeShipping && fees.amountToFreeShipping > 0 && _react2.default.createElement("div", {
    className: "fs-11 fw-mid"
  }, "Add", " ", _react2.default.createElement("span", {
    className: "c-brand fw-bold"
  }, "$" + fees.amountToFreeShipping), " ", "to get free shipping")), fees && fees.processing && _react2.default.createElement("div", {
    className: "addl-shipping d-flex flex-jsb mar-h-4 fs-12"
  }, _react2.default.createElement("div", {
    className: "mar-0 pad-0"
  }, "Add'l Shipping & Handling", _react2.default.createElement(_tooltip2.default, {
    text: "Add'l shipping & handling for customers with shipping address in Hawaii, Alaska, Puerto Rico, Canada, and UK",
    icon: "help"
  })), _react2.default.createElement("div", {
    className: "mar-0 pad-0"
  }, "$" + fees.processing)), fees && fees.tax != null && _react2.default.createElement("div", {
    className: "d-flex flex-jsb tax fs-12"
  }, _react2.default.createElement("p", {
    className: "mar-0 pad-0 fw-bold"
  }, "Tax"), _react2.default.createElement("p", {
    className: "mar-0 pad-0"
  }, "$" + fees.tax))), _react2.default.createElement("div", {
    className: "d-flex flex-jsb pad-8 bcg-brand"
  }, _react2.default.createElement("div", {
    className: "c-white"
  }, "TOTAL"), _react2.default.createElement("div", {
    className: "c-white"
  }, "$", total)), _react2.default.createElement("div", {
    className: "cart-sub-copy pad-16"
  }, _react2.default.createElement("p", {
    className: "mar-0 pad-0 fs-12",
    dangerouslySetInnerHTML: {
      __html: cartText
    }
  })), children && children.map(function (child) {
    if (child.placementIndex > 1) {
      return _react2.default.createElement(_react2.default.Fragment, {
        key: child.key
      }, child.component);
    }
  })), _react2.default.createElement(_HeaderContext2.default.Consumer, null, function (context) {
    return _react2.default.createElement("div", {
      className: "cart-page-overlay",
      onClick: function onClick() {
        return context.setExpandedMenu();
      }
    });
  }));
};

exports.default = CartSubMenu;